import { Component } from '@angular/core';

import { DynamicFormService } from '@ntap/common';

import {
  ImagePanelItemProviderService,
  ParentItemProviderService
} from '@app/shared';

@Component({
  selector: 'app-mjesto',
  templateUrl: './mjesto.component.html',
  providers: [
    DynamicFormService,
    ParentItemProviderService,
    ImagePanelItemProviderService
  ]
})
export class MjestoComponent {}
